import SimplePage from "@/components/layout/SimplePage";

export default function ZoomMeetings() {
  return (
    <SimplePage
      title="Zoom Meetings"
      eyebrow="Join From Anywhere"
      subtitle="For members traveling, snowbirds away from Brevard, and friends across the country - join us online."
      path="/calendar/zoom"
      ctaLabel="Email for Zoom links"
    >
      <p>
        TIOB offers Zoom access for many of our regular gatherings, including
        select Shabbat services, Torah study, adult-education classes, and
        committee meetings. This allows members who are traveling, homebound,
        or living elsewhere part of the year to remain connected to the
        community.
      </p>

      <h2>How to Get Zoom Links</h2>
      <p>
        For security and privacy, Zoom links are not posted publicly. To
        receive the weekly Zoom schedule and meeting links, please email the
        office at{" "}
        <a href="mailto:tioffice@tiofbrevard.com">tioffice@tiofbrevard.com</a>{" "}
        and ask to be added to the Zoom distribution list. Members in good
        standing are added automatically.
      </p>

      <h2>What's Typically on Zoom</h2>
      <ul>
        <li>Selected Friday-night Shabbat services (streamed in parallel with in-person)</li>
        <li>Saturday-morning Torah study</li>
        <li>Adult Hebrew classes</li>
        <li>Torah Study</li>
        <li>Board and committee meetings</li>
        <li>Special guest lectures</li>
      </ul>

      <h2>Best Practices</h2>
      <ul>
        <li>Test your audio and video before the first meeting</li>
        <li>Mute when you're not speaking, especially during services</li>
        <li>For services, you're encouraged to leave video on so we can see you</li>
        <li>Hebrew/English prayer-book PDFs can be sent in advance on request</li>
      </ul>

      <p>
        Questions or trouble connecting? Call the office at (321) 631-9494 and
        we'll help you get set up.
      </p>
    </SimplePage>
  );
}
